module.exports = __webpack_public_path__ + "img/icon_needs_selected.862ae45f.svg";